import React from "react";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import LimitedTicketDesktop from "./limitedTicket";
import LimitedTicketMobile from "./limitedTicketMobile";

interface IProps {
  ticket: Ticket;
}

const LimitedTicket: React.FC<IProps> = ({ ticket }: IProps) => {
  const isDesktop = useDesktopSize();
  return (
    <React.Fragment>
      {ticket.passtype === 4 && ticket.ticket === true && (
        <React.Fragment>
          {isDesktop ? <LimitedTicketDesktop ticket={ticket} /> : <LimitedTicketMobile ticket={ticket} />}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default LimitedTicket;
